import { Component, OnInit } from '@angular/core'
import { DatepickerView } from 'app/shared/datepicker/datepicker.models'

@Component({
    selector: 'sbw-datepicker-demo',
    templateUrl: './datepicker-demo.component.html'
})
export class DatepickerDemoComponent implements OnInit {
    public selectedDate: Date = new Date(2017, 3, 15)
    public datepickerViewLocale: DatepickerView = new DatepickerView('da')
    public datepickerViewPlaceholder: DatepickerView = new DatepickerView('en', null, null, null, 'Please select a date')
    public datepickerViewRestrictDates: DatepickerView = new DatepickerView('en', new Date(2017, 3, 5), new Date(2017, 3, 25), [new Date(2017, 3, 17), new Date(2017, 3, 18), new Date(2017, 3, 20)])
    public datepickerViewYearSelector: DatepickerView = new DatepickerView('en', null, null, null, null, '2010:2020')
    public datepickerViewDefaultDate = new DatepickerView('en', null, null, null, null, null, false, new Date(2017, 4, 1))
    public selectedDateNgModel: Date = new Date(2017, 3, 15)
    public dateFormat = 'DD/MM/YYYY'

    constructor() { }

    ngOnInit() {
    }
}
